/**
 * Shared formatting helpers for the archivio feature.
 *
 * `formatDate` mirrors the inline implementations previously duplicated in
 * `PraticaRow.tsx`, `DatiPraticaCard.tsx` and `DocumentoDownloadCard.tsx`.
 * Falls back to a slice of the ISO string when `Date` parsing throws — this
 * preserves backward-compat with the original try/catch blocks.
 */

/**
 * Format an ISO date string as `dd/mm/yyyy` using the Italian locale.
 * Returns `'—'` when the input is undefined/null/empty (UI placeholder).
 */
export function formatDate(iso?: string | null): string {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('it-IT');
  } catch {
    return iso.slice(0, 10);
  }
}
